import { withAppCrashIfException } from 'epic';
import { secondaryMarketLimitOrderEpic } from 'epic/secondaryMarket/limit-order';
import { keepAliveStreamingEpic, updatePriceStreamingEpic } from 'epic/secondaryMarket/realtimeEpic';
import { secondaryWorkspaceReloadLimitOrderByOrderIdEpic } from 'epic/secondaryMarket/secondaryWorkspaceReloadLimitOrderByOrderIdEpic';
import { secondaryWorkspaceReloadOrdersEpic } from 'epic/secondaryMarket/secondaryWorkspaceReloadOrdersEpic';
import { combineEpics } from 'redux-observable';
import { limitOrderSelectors } from 'state/secondaryMarket/limit-order/limitOrder.selector';
import { liveSelectors } from 'state/secondaryMarket/live/live.selector';
import { getKeepAliveDlpProductIds } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.selector';

import { secondaryMarketCpOrder } from './cpOrder';
import { secondaryMarketDlpOrder } from './dlpOrder';
import { secondaryMarketLiveQuote } from './live';
import { secondaryMarketPostEventsWorkspaceEpic } from './postEventsWorkspace';
import { secondaryMarketProductSearchEpic } from './productSearch';
import { secondaryMarketQuotesWorkspaceEpic } from './quotesWorkspace';
import { secondaryMarketRealtimeQuotes } from './realtimeQuote';
import { secondaryMarketReferentials } from './referential';
import { secondaryWorkspaceOpenTabFromTradeAllocationEpic } from './secondaryWorkspaceOpenTabFromTradeAllocationEpic';
import { secondaryWorkspaceReloadByIsinEpic } from './secondaryWorkspaceReloadByIsinEpic';
import { secondaryWorkspaceReloadByOrderIdEpic } from './secondaryWorkspaceReloadByOrderIdEpic';
import { secondaryWorkspaceReloadLiveByOrderIdEpic } from './secondaryWorkspaceReloadLiveByOrderIdEpic';

export const secondaryMarketEpic = () =>
  withAppCrashIfException(
    'secondaryMarket',
    combineEpics(
      withAppCrashIfException(secondaryWorkspaceReloadOrdersEpic.name, secondaryWorkspaceReloadOrdersEpic()),
      withAppCrashIfException('secondaryMarketProductSearch', secondaryMarketProductSearchEpic()),
      withAppCrashIfException('secondaryMarketQuotesWorkspace', secondaryMarketQuotesWorkspaceEpic()),
      withAppCrashIfException('secondaryMarketPostEventsWorkspaceEpic', secondaryMarketPostEventsWorkspaceEpic()),
      withAppCrashIfException('secondaryMarketRealtimeQuotes', secondaryMarketRealtimeQuotes()),
      withAppCrashIfException('secondaryMarketCpOrder', secondaryMarketCpOrder()),
      withAppCrashIfException('secondaryMarketLimitOrderEpic', secondaryMarketLimitOrderEpic()),
      withAppCrashIfException('secondaryMarketLiveQuote', secondaryMarketLiveQuote()),
      withAppCrashIfException('secondaryMarketReferentials', secondaryMarketReferentials()),
      withAppCrashIfException('secondaryWorkspaceReloadByIsinEpic', secondaryWorkspaceReloadByIsinEpic()),
      withAppCrashIfException('secondaryWorkspaceReloadByOrderIdEpic', secondaryWorkspaceReloadByOrderIdEpic()),
      withAppCrashIfException('secondaryWorkspaceReloadLiveByOrderIdEpic', secondaryWorkspaceReloadLiveByOrderIdEpic()),
      withAppCrashIfException(
        'secondaryWorkspaceReloadLimitOrderByOrderIdEpic',
        secondaryWorkspaceReloadLimitOrderByOrderIdEpic(),
      ),
      withAppCrashIfException(
        'secondaryWorkspaceOpenTabFromTradeAllocationEpic',
        secondaryWorkspaceOpenTabFromTradeAllocationEpic(),
      ),
      withAppCrashIfException(
        'keepAliveIcomStreamingEpic',
        keepAliveStreamingEpic('Icom', [
          liveSelectors.getKeepAliveProductIds,
          limitOrderSelectors.getKeepAliveProductIds,
        ]),
      ),
      withAppCrashIfException('keepAliveDlpStreamingEpic', keepAliveStreamingEpic('Dlp', [getKeepAliveDlpProductIds])),
      withAppCrashIfException('updatePriceStreamingEpic', updatePriceStreamingEpic()),
      withAppCrashIfException('secondaryMarketDlpOrder', secondaryMarketDlpOrder()),
    ),
  );
